import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const CityCard = ({ city }) => {
  const [t] = useTranslation("global");

  return (
    <div className={styles.cityCard}>
      <div className={styles.imageContainer}>
        {city.image_url ? (
          <img
            className={styles.image}
            src={city.image_url}
            alt={city.homepage_title || "City image"}
          />
        ) : (
          <div className={styles.imagePlaceholder}>
            <span>{city.homepage_title || city.key}</span>
          </div>
        )}
        
        {/* Centered city name (visible when not hovered) */}
        {/* <div className={styles.cityNameCenter}>
          {city.name || city.url}
        </div> */}
        
        <div className={styles.overlay}>
          <a className={styles.cityButton} href={`/static/${city.key}`}>
           <p>{city.homepage_title|| city.key}</p> 
          </a>
        </div>
      </div>
      
      <div className={styles.content}>
        <div className={styles.descriptionContainer}>
          <p
            className={styles.description}
            dangerouslySetInnerHTML={{ __html: city.frontend_description }}
          />
          <a className={styles.seeMoreLink} href={`/static/${city.key}`}>
            {t("home.seeplace")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default CityCard;